import { IconProps } from "../../utils/global-types/global-types";

const OperationsIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <g clipPath="url(#clip0_4130_53559)">
      <g fill="currentColor" clipPath="url(#clip1_4130_53559)">
        <path d="m13.763 10.126-.626-.36c.055-.27.082-.52.082-.766s-.027-.495-.082-.764l.626-.361a.47.47 0 0 0 .171-.64l-.937-1.625a.47.47 0 0 0-.64-.171l-.62.358a4.2 4.2 0 0 0-1.33-.76v-.724a.47.47 0 0 0-.47-.469H8.062a.47.47 0 0 0-.468.469v.724c-.491.173-.942.43-1.33.76l-.62-.358a.47.47 0 0 0-.64.171l-.938 1.624a.47.47 0 0 0 .171.64l.626.362c-.055.27-.082.518-.082.764 0 .247.027.496.082.765l-.626.361a.47.47 0 0 0-.171.64l.937 1.624c.13.225.416.302.64.172l.62-.358c.389.33.84.587 1.33.76v.724c0 .259.21.469.47.469h1.874c.26 0 .47-.21.47-.469v-.724c.49-.173.94-.43 1.33-.76l.62.358c.224.13.51.053.64-.171l.937-1.624a.47.47 0 0 0-.171-.64M9 10.406c-.775 0-1.406-.63-1.406-1.406S8.224 7.594 9 7.594s1.406.631 1.406 1.406c0 .776-.63 1.407-1.406 1.407"></path>
        <path d="m15.41 4.212-.662-1.989a.469.469 0 1 0-.89.297l.057.169a8.4 8.4 0 0 0-1.351-.84A8.1 8.1 0 0 0 9 1a7.94 7.94 0 0 0-5.648 2.353A7.94 7.94 0 0 0 1 9c0 .982.206 1.988.613 2.99a.469.469 0 1 0 .869-.353C2.12 10.747 1.937 9.86 1.937 9A7.07 7.07 0 0 1 9 1.938c1.43 0 2.872.475 4.071 1.3a.469.469 0 0 0-.242.904l1.989.663a.469.469 0 0 0 .593-.593M16.387 6.012a.469.469 0 0 0-.869.352c.361.89.544 1.776.544 2.636a7.07 7.07 0 0 1-7.063 7.063c-1.429 0-2.872-.475-4.07-1.3a.469.469 0 0 0 .241-.904l-1.989-.663a.469.469 0 0 0-.592.593l.662 1.989a.469.469 0 1 0 .89-.297l-.057-.169c.421.32.874.603 1.352.84 1.12.555 2.352.848 3.563.848a7.94 7.94 0 0 0 5.648-2.352A7.94 7.94 0 0 0 17 9c0-.981-.207-1.987-.613-2.988"></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4130_53559">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
      <clipPath id="clip1_4130_53559">
        <path fill="#fff" d="M1 1h16v16H1z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default OperationsIcon;
